import Index1 from './views/index1.vue'
import Index2 from './views/index2.vue'

import Index from './views/index.vue'
import DiFangZhiList1 from './views/DiFangZhiList1.vue'
import DiFangZhi1 from './ChildrenRouter/DiFangZhi2.vue'
import DiFangZhiNeiRong1 from './ChildrenRouter/DiFangZhiNeiRong1.vue'
import Login from './ChildrenRouter/Login.vue'
import Register from './ChildrenRouter/Register.vue'
import Personal from './ChildrenRouter/Personal.vue'
import Upload from './ChildrenRouter/UploadPage.vue'
import UploadPageJX from './ChildrenRouter/UploadPageJX.vue'

import UploadfromUser from './ChildrenRouter/UploadfromUser.vue';
import UploadRecord from "./ChildrenRouter/UploadRecord.vue";
import DownloadRecord from "./ChildrenRouter/DownloadRecord.vue";
import AutoRelayPage from "./ChildrenRouter/AutoRelayPage.vue";
import RetrievePassword from "./ChildrenRouter/RetrievePassword.vue";
import newsPage from "./ChildrenRouter/newsPage.vue";
import newsPage2 from "./ChildrenRouter/newsPage2.vue";

import bei from "./ChildrenRouter/bei.vue";
const router = [{
        path: '/index2',
        name: 'index2',
        component: Index2,
    },
    {
        path: '/index1',
        name: 'index1',
        component: Index1,
    },
    {
        path: '/',
        redirect: '/index',
    },
    {
        path: '/index',
        name: 'home',
        component: Index,
        meta: {
            keepAlive: false // 需要缓存
        },
    },

    {
        path: '/DiFangZhiList1',
        component: DiFangZhiList1,
        meta: {
            keepAlive: false // 需要缓存
        },
        children: [ //这里就是二级路由的配置
            {
                path: '/',
                name: 'DiFangZhi1',
                component: DiFangZhi1,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/DiFangZhi1',
                name: 'DiFangZhi1',
                component: DiFangZhi1,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/upload',
                name: 'Upload',
                component: Upload,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/newsPage2',
                name: 'newsPage2',
                component: newsPage2,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/UploadPageJX',
                name: 'UploadPageJX',
                component: UploadPageJX,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/uploadfromuser',
                name: 'UploadfromUser',
                component: UploadfromUser,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/login',
                name: 'Login',
                component: Login,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/register',
                name: 'Register',
                component: Register,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/DiFangZhiNeiRong1',
                name: 'DiFangZhiNeiRong1',
                component: DiFangZhiNeiRong1,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/personal',
                name: 'Personal',
                component: Personal,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/upload/record',
                name: 'UploadRecord',
                component: UploadRecord,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/bei',
                name: 'bei',
                component: bei,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/download',
                name: 'DownloadRecord',
                component: DownloadRecord,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/autoReplayPage',
                name: 'AutoRelayPage',
                component: AutoRelayPage,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/RetrievePassword',
                name: 'RetrievePassword',
                component: RetrievePassword,
                meta: {
                    keepAlive: false // 不需要缓存
                }
            },
            {
                path: '/newsPage',
                name: 'newsPage',
                component: newsPage,
            }
        ]
    }
]


export default router